/* Bundle offers follow published, authored contents. No cart or variant mutation. */
(function () {
  'use strict';
  if (window.BotBundleOffers) { window.BotBundleOffers.init(); return; }
  var TTL = 5 * 60 * 1000;
  var pending = new Map();
  function normalize(text) {
    return String(text || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/&(?:amp;)?/g, ' and ').replace(/[’']/g, '')
      .replace(/[^a-z0-9%]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function canonical(text) {
    return normalize(text)
      .replace(/\bmoisturizers?\b/g, function (word) { return word.replace('moisturizer', 'moisturiser'); })
      .replace(/\b(?:vitamin b3 )?niacinamide\b/g, 'niacinamide')
      .replace(/\b(?:aha )?glycolic(?: acid)?\b/g, 'glycolic')
      .replace(/\b(?:bha )?salicylic(?: acid)?\b/g, 'salicylic')
      .replace(/\b(\d+(?: \d+)?)\s*(?:ml|grams?|g|oz|litres?)\b/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function phrase(haystack, needle) { return (' ' + haystack + ' ').includes(' ' + needle + ' '); }
  function brandNames(vendor) {
    var full = canonical(vendor);
    return Array.from(new Set([full, full.replace(/ (?:skincare|skin care|cosmetics|organics)$/, '')])).filter(function (name) { return name.length > 2; });
  }
  function genericName(name) { return /^(?:leave in conditioner|deep conditioner(?: treatment)?|conditioner|shampoo|hair oil|hair spray|shea butter|body oil|body lotion|face mist|serum|cream|moisturiser|moisturizer|sunscreen|cleanser|toner|soap|hair balm|beard oil|beard butter)$/.test(name); }
  function names(product) {
    var vendor = canonical(product.vendor);
    var title = canonical(product.title);
    if (vendor && title.startsWith(vendor + ' ')) title = title.slice(vendor.length + 1);
    title = title.replace(/^the /, '').replace(/ (?:by|from) [a-z ]+$/, '').trim();
    var out = [title];
    if (/\b(?:face|facial) serum\b/.test(title)) out.push(title.replace(/\b(?:face|facial) serum\b/, 'serum'));
    // A dash subtitle describes benefits; it is not part of the component name.
    var parts = String(product.title).split(/\s+[–—]\s+|\s+-\s+/);
    var first = parts.length > 1 && /^exfoliating (?:and|&) acne control$/i.test(parts.slice(1).join(' ').trim()) ? parts[0] : product.title;
    first = canonical(first);
    if (vendor && first.startsWith(vendor + ' ')) first = first.slice(vendor.length + 1);
    out.push(first.replace(/^the /, '').trim());
    if (parts.length === 2 && first === canonical(product.title)) out.push(canonical(parts[0] + ' in ' + parts[1]).replace(/^the /, '').trim());
    if (!product.bundle) {
      if (/\bleave in conditioner$/.test(title)) out.push('leave in conditioner');
      else if (/\bdeep conditioner(?: treatment)?$/.test(title)) out.push('deep conditioner');
      else if (/\bconditioner$/.test(title)) out.push('conditioner');
      if (/\bshampoo$/.test(title)) out.push('shampoo');
      if (/\bshea butter$/.test(title)) out.push('shea butter');
      if (/^hair (?:cold pressed )?oil$/.test(title)) out.push('hair oil');
    }
    return Array.from(new Set(out)).filter(function (name) {
      return name.length >= 4 && name.split(' ').length >= 1;
    });
  }
  function authoredBlocks(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    doc.querySelectorAll('br').forEach(function (el) { el.replaceWith(doc.createTextNode('\n')); });
    doc.querySelectorAll('script,style,iframe,img,svg,video,audio,form,.jdgm-widget,.jdgm-rev-widg,.shopify-app-block').forEach(function (el) { el.remove(); });
    var blocks = Array.from(doc.body.querySelectorAll('p,li,h1,h2,h3,h4,h5,h6,div'))
      .filter(function (el) { return !el.querySelector('p,li,h1,h2,h3,h4,h5,h6,div'); });
    if (!blocks.length) blocks = [doc.body];
    var ingredients = false, headings = [], activeHeading = '', contexts = new Map();
    var result = blocks.flatMap(function (el) {
      var text = canonical(el.textContent);
      var heading = el.querySelector('strong,b') || (/^H[1-6]$/.test(el.tagName) ? el : null);
      var headingText = heading && canonical(heading.textContent);
      if (headingText && text.startsWith(headingText) && !/\bingredients\b/.test(headingText) && /\b(?:serum|cream|moisturiser|moisturizer|wash|lotion|oil|cleanser|mist|mask|toner|conditioner|shampoo|balm)\b/.test(headingText)) ingredients = false;
      if (/^(?:key |full |active |list of )?ingredients\b/.test(text)) ingredients = true;
      if (/^(?:what s inside|whats inside|what is inside|contents|this (?:box|bundle|kit) contains|step [0-9])\b/.test(text)) ingredients = false;
      if (ingredients) return [];
      if (headingText) {
        headings.push(headingText);
        if (headingText.split(' ').length <= 16 && /\b(?:serum|cream|moisturiser|wash|lotion|oil|cleanser|mist|mask|toner|conditioner|shampoo|balm|management|support)\b/.test(headingText)) activeHeading = headingText.replace(/^the /, '');
        else activeHeading = '';
      }
      // Ingredient lists copied under a component heading are not component offers.
      if (/\b(?:aqua|water)\b/.test(text) && (el.textContent.match(/,/g) || []).length > 5) return '';
      return el.textContent.split(/\n/).flatMap(function (fragment) {
        var step = /^step [0-9]\b/.test(canonical(fragment));
        return fragment.split(/(?<=[.!?])\s+/).map(canonical).filter(function (line) {
          if (!line || /\b(?:sold separately|not included|does not include|do not use with)\b/.test(line)) return false;
          var allowed = step || !/\b(?:pair with|follow with|layer with|use with sunscreen|apply a broad spectrum sunscreen)\b/.test(line);
          if (allowed && activeHeading) contexts.set(line, activeHeading);
          return allowed;
        });
      });
    }).filter(Boolean);
    result.headings = headings;
    result.contexts = contexts;
    return result;
  }
  function indexProducts(products) {
    var index = new Map();
    products.forEach(function (p) {
      names(p).forEach(function (name) {
        if (!index.has(name)) index.set(name, []);
        index.get(name).push(p);
      });
    });
    return index;
  }
  function occurrences(text, name) {
    var out = [], padded = ' ' + text + ' ', query = ' ' + name + ' ', pos = 0;
    while ((pos = padded.indexOf(query, pos)) !== -1) { out.push(pos); pos += query.length - 1; }
    return out;
  }
  function matches(product, bundle, index) {
    if (String(product.id) === String(bundle.id) || !bundle.bundle) return false;
    var blocks = authoredBlocks(bundle.description);
    var brand = canonical(product.vendor), parentBrand = canonical(bundle.vendor);
    return names(product).some(function (name) {
      var identities = index.get(name) || [];
      return blocks.some(function (block) {
        var heading = blocks.contexts.get(block);
        var headingProducts = heading ? (index.get(heading) || []) : [];
        if (headingProducts.length && !headingProducts.some(function (p) { return String(p.id) === String(product.id); })) return false;
        if ((genericName(name) || name.split(' ').length < 3) && brand !== parentBrand && !brandNames(product.vendor).some(function (v) { return phrase(block, v); })) return false;
        if (!/\b(?:wash|lotion|oil|serum|cream|moisturiser|cleanser|mist|mask|toner|conditioner|shampoo|butter|balm|gel|spray|soap|exfoliant|exfoliating|sunscreen|essence|brush|comb|patch|cleanse|support)\b/.test(name) && !(name.split(' ').length >= 2 && blocks.headings.some(function (h) { return h === name || h === 'the ' + name; }))) return false;
        return occurrences(block, name).some(function (pos) {
          // Only suppress an occurrence nested in a longer named product form.
          var nested = false;
          index.forEach(function (otherProducts, otherName) {
            if (otherName.length <= name.length || !phrase(otherName, name)) return;
            if (!otherProducts.some(function (p) { return String(p.id) !== String(product.id); })) return;
            if (occurrences(block, otherName).some(function (start) { return start <= pos && start + otherName.length >= pos + name.length; })) nested = true;
          });
          if (nested) return false;
          if (genericName(name)) {
            var sameBrand = identities.filter(function (p) { return canonical(p.vendor) === brand && !p.bundle; });
            if (sameBrand.length !== 1) return false;
          }
          var nearby = block.slice(Math.max(0, pos - 40), pos + name.length + 20);
          var branded = identities.filter(function (p) { return brandNames(p.vendor).some(function (v) { return phrase(nearby, v); }); });
          if (branded.length) return branded.length === 1 && String(branded[0].id) === String(product.id);
          var ownBrand = identities.filter(function (p) { return canonical(p.vendor) === parentBrand; });
          if (ownBrand.length) return brand === parentBrand && ownBrand.length === 1;
          return identities.length === 1;
        });
      });
    });
  }
  async function getJSON(url) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, cache: 'no-cache' });
      if (!response.ok) throw new Error('Bundle source unavailable');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function validProducts(items) {
    return Array.isArray(items) && items.every(function (p) {
      return p && /^\d+$/.test(String(p.id)) && typeof p.title === 'string' && typeof p.vendor === 'string' && typeof p.handle === 'string' && p.handle.length > 0 && !/[\/\\?#\x00-\x20]/.test(p.handle) && typeof p.bundle === 'boolean';
    });
  }
  async function catalogue(endpoint) {
    var url = new URL(endpoint, location.origin);
    if (url.origin !== location.origin || !/\/collections\/all\/?$/.test(url.pathname) || url.searchParams.get('view') !== 'bot-bundle-catalog') throw new Error('Invalid source');
    var key = 'bot:bundle-membership:v1:' + location.host + ':' + url.pathname + ':' + (window.Shopify && Shopify.theme ? Shopify.theme.id : '');
    if (pending.has(key)) return pending.get(key);
    var promise = (async function () {
      try {
        var cached = JSON.parse(sessionStorage.getItem(key));
        if (cached && cached.complete && Date.now() - cached.at >= 0 && Date.now() - cached.at < TTL && validProducts(cached.products)) return cached.products;
      } catch (_) { /* Storage is optional. */ }
      var products = [], seen = new Set(), totalPages = null, totalItems = null;
      function consume(data, page) {
        if (data.version !== 1 || data.page !== page || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 100 || !validProducts(data.products)) throw new Error('Incomplete bundle source');
        if (!Number.isInteger(data.items) || data.items < 0 || (totalItems !== null && data.items !== totalItems)) throw new Error('Catalogue count changed');
        if (totalPages !== null && data.pages !== totalPages) throw new Error('Catalogue changed during pagination');
        totalPages = data.pages; totalItems = data.items;
        data.products.forEach(function (p) { if (seen.has(String(p.id))) throw new Error('Repeated catalogue product'); seen.add(String(p.id)); products.push(p); });
      }
      url.searchParams.set('page', '1');
      consume(await getJSON(url.pathname + url.search), 1);
      for (var page = 2; page <= totalPages; page += 3) {
        var pageNumbers = Array.from({ length: Math.min(3, totalPages - page + 1) }, function (_, i) { return page + i; });
        var batch = await Promise.all(pageNumbers.map(function (number) {
          var next = new URL(url); next.searchParams.set('page', String(number));
          return getJSON(next.pathname + next.search);
        }));
        batch.forEach(function (data, i) { consume(data, pageNumbers[i]); });
      }
      if (products.length !== totalItems) throw new Error('Incomplete catalogue count');
      try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), complete: true, products: products })); } catch (_) { /* Quota or private mode: use current response. */ }
      return products;
    })();
    pending.set(key, promise);
    try { return await promise; } finally { pending.delete(key); }
  }
  function element(tag, className, text) {
    var el = document.createElement(tag); if (className) el.className = className; if (text != null) el.textContent = text; return el;
  }
  function card(data, root) {
    if (!data || !data.available || typeof data.handle !== 'string' || !data.handle || /[\/\\?#\x00-\x20]/.test(data.handle)) return null;
    var link = element('a', 'bot-bundle-upgrade__card');
    link.href = root + encodeURIComponent(data.handle);
    if (data.image) {
      var imageURL = new URL(data.image, location.origin);
      if (imageURL.protocol === 'https:' && (imageURL.origin === location.origin || imageURL.hostname === 'cdn.shopify.com')) {
        var image = element('img', 'bot-bundle-upgrade__image'); image.src = imageURL.href; image.alt = ''; image.width = 56; image.height = 56; image.loading = 'lazy'; link.appendChild(image);
      }
    }
    var copy = element('span', 'bot-bundle-upgrade__copy');
    copy.appendChild(element('strong', '', data.title));
    copy.appendChild(element('span', '', (data.varies ? 'From ' : '') + data.price));
    copy.appendChild(element('span', 'bot-bundle-upgrade__variant', 'View contents and options'));
    copy.appendChild(element('span', 'bot-bundle-upgrade__link', 'View bundle →'));
    link.appendChild(copy); return link;
  }
  async function fill(module) {
    if (module.dataset.bundleState) return;
    module.dataset.bundleState = 'loading';
    try {
      var root = module.dataset.cardRoot;
      if (!/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/$/.test(root)) throw new Error('Invalid product route');
      var products = await catalogue(module.dataset.catalogUrl);
      var product = products.find(function (p) { return String(p.id) === module.dataset.productId; });
      if (!product) { module.dataset.bundleState = 'empty'; return; }
      var index = indexProducts(products);
      var offers = products.filter(function (p) { return matches(product, p, index); });
      // Current card requests deliberately bypass persistent membership cache.
      var cards = [];
      for (var start = 0; start < offers.length; start += 4) {
        var batch = await Promise.all(offers.slice(start, start + 4).map(async function (offer) {
          try {
            var current = await getJSON(root + encodeURIComponent(offer.handle) + '?view=bot-bundle-card');
            return String(current.id) === String(offer.id) ? card(current, root) : null;
          } catch (_) { return null; }
        }));
        cards.push.apply(cards, batch.filter(Boolean));
      }
      if (!module.isConnected) return;
      var target = module.querySelector('[data-bot-bundle-cards]');
      target.replaceChildren.apply(target, cards);
      module.hidden = !cards.length;
      module.dataset.bundleState = cards.length ? 'ready' : 'empty';
    } catch (_) { module.hidden = true; module.dataset.bundleState = 'unavailable'; }
  }
  function init() { document.querySelectorAll('[data-bot-bundle-upgrades]').forEach(fill); }
  window.BotBundleOffers = { init: init, normalize: canonical, names: names, authoredBlocks: authoredBlocks, indexProducts: indexProducts, matches: matches };
  init();
  document.addEventListener('shopify:section:load', init);
})();
